export default function PagePermitCheckerServiceProvider() {
  this.$get = ($auth, $q, $location, $security, $routeParams) => {
    'ngInject';

    function PagePermitCheckerService() {

      const self = this;

      self.check = access => {
        const deferred = $q.defer();
        const logoutRequired = access && access.requireLogout;

        if (logoutRequired) {
          $auth.logout(true, () => deferred.resolve());
        } else {
          $auth.refreshAuthentication()
            .then(user => {
              const currentUrl = encodeURIComponent($location.url());
              const loginRequired = (!access || access.requireLogin);
              const roleRequired = (!access || access.hasAuthority);
              const isRequest = (!access || access.isRequest);

              if (loginRequired && !$auth.isLogin()) {
                deferred.reject();
                redirectToLogin(currentUrl);
              } else if (loginRequired && $auth.isPartiallyRegistered() && user.signUpType === 'LOCAL') {
                deferred.reject();
                redirectToCompleteRegistration(user, currentUrl);
              } else if (loginRequired && user.role !== roleRequired) {
                deferred.reject();
                redirectToUserPage($location.url())
              } else {
                $security.check($location.path(), $routeParams);
                deferred.resolve();
              }
            });
        }
        return deferred.promise;
      }

      const redirectToUserPage = (isRequest) => {
        const requestId = $routeParams.requestId || $routeParams.id;

        if ($auth.isPartiallyRegistered()) {
          redirectTo('/complete-social-registration', {});
        } else if ($auth.isFullyLoggedIn()) {
          if ($auth.isUser()) {
            if ($auth.isActivatedUser()) {
              if (isRequest) {
                redirectTo('/bicycle-owner/service-bookings/' + requestId, {});
              } else {
                redirectTo('/bicycle-owner/service-bookings', {});
              }
            } else {
              redirectTo('/bicycle-owner/complete-registration', {});
            }
          } else if ($auth.isBikeOrganisationOwner()) {
            if (isRequest) {
              redirectTo('/organisation/' + $auth.user().organisations[0].id + '/service-bookings/' + requestId, {});
            } else {
              redirectTo('/organisations', {});
            }
          } else if ($auth.isMechanic()) {
            if (isRequest) {
              redirectTo('/service-provider/service-bookings/' + requestId, {});
            } else {
              redirectTo('/service-provider/service-bookings', {});
            }
          } else if ($auth.isAdmin()) {
            if (isRequest) {
              redirectTo('/admin/bookings/service-bookings/' + requestId, {});
            } else {
              redirectTo('/admin/users', {});
            }
          }
        }
      }

      const redirectToLogin = currentUrl => {
        redirectTo('/login', {'redirect': currentUrl});
      }

      const redirectToCompleteRegistration = (user, currentUrl) => {
        redirectTo('/complete-registration', {
          'redirect': currentUrl,
          'fn': user.name,
          'sn': user.surname
        });
      };

      const redirectTo = (path, params) => {
        if ($location.path() !== path) {
          $location.path(path).search(params);
        }
      }

    }

    return new PagePermitCheckerService();
  };
}